<template>
    <div class="ei-search">
        <input class="search-text" type="text"/>
        <a class="search-btn" href="#"></a>
    </div>
</template>

<script>
	export default {
		name: "EiSearch"
	}
</script>

<style scoped>
    .ei-search {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);

    }

    .search-text {

    }

    .search-btn{

    }
</style>
